import script from "./Credentials.vue?vue&type=script&setup=true&lang=js"
export * from "./Credentials.vue?vue&type=script&setup=true&lang=js"

import "./Credentials.vue?vue&type=style&index=0&id=1143b8cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1143b8cc"]])

export default __exports__